export default "__VITE_ASSET__BCvo3abC__"